
(function () {
  if (customElements.get("collection-mega-menu")) return;

  const NAV_KEYS = ["ArrowDown", "ArrowUp", "Home", "End"];

  class CollectionMegaMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll(".cmm_coll_item"));
      this.panels = Array.from(this.querySelectorAll(".cmm_panels > .cmm_products"));
      this.promos = Array.from(this.querySelectorAll(".cmm_promos > .cmm_promo_panel"));
      if (this.items.length < 1) return;

      this.links = this.items.map((item) => item.querySelector(".cmm_coll_link"));
      this.activeIndex = 0;

      this.items.forEach((item, index) => {
        item.addEventListener("pointerenter", () => this.activate(index));
        item.addEventListener("focusin", () => this.activate(index));
      });

      this.links.forEach((link, index) => {
        if (!link) return;
        link.addEventListener("keydown", (event) => this.handleKeydown(event, index));
      });

      this.addEventListener("pointerleave", () => this.reset());

      this.hydrateHost = this.closest(".parent_li") || this;
      this.hydrateImages = this.hydrateImages.bind(this);
      this.hydrateHost.addEventListener("pointerenter", this.hydrateImages, { once: true });
      this.hydrateHost.addEventListener("focusin", this.hydrateImages, { once: true });
      this.hydrateHost.addEventListener("touchstart", this.hydrateImages, { once: true, passive: true });
    }

    hydrateImages() {
      this.querySelectorAll("img[data-srcset]").forEach((img) => {
        const srcset = img.getAttribute("data-srcset");
        const src = img.getAttribute("data-src");
        if (srcset) img.srcset = srcset;
        if (src) img.src = src;
        img.removeAttribute("data-srcset");
        img.removeAttribute("data-src");
      });
    }

    handleKeydown(event, index) {
      if (!NAV_KEYS.includes(event.key)) return;
      event.preventDefault();

      const total = this.links.length;
      let next = index;

      if (event.key === "ArrowDown") next = (index + 1) % total;
      if (event.key === "ArrowUp") next = (index - 1 + total) % total;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = total - 1;

      this.activate(next);
      this.links[next]?.focus();
    }

    activate(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;

      this.items.forEach((item, i) => item.classList.toggle("is_active", i === index));

      this.links.forEach((link, i) => {
        if (!link) return;
        link.setAttribute("aria-expanded", String(i === index));
      });

      this.swap(this.panels, index);
      this.swap(this.promos, index);
    }

   
    swap(group, index) {
      group.forEach((el, i) => {
        const isActive = i === index;
        el.classList.toggle("is_active", isActive);

        if (isActive) {
          el.removeAttribute("inert");
          el.removeAttribute("aria-hidden");
        } else {
          el.setAttribute("inert", "");
          el.setAttribute("aria-hidden", "true");
        }
      });
    }

    reset() {
      if (this.contains(document.activeElement)) return;
      this.activate(0);
    }
  }

  customElements.define("collection-mega-menu", CollectionMegaMenu);
})();
